import { colors } from 'design-system';

const getPercentageGrowthColor = (percentageGrowth: number): string => {
  if (percentageGrowth > 0) {
    return colors.shamrock;
  }

  if (percentageGrowth < 0) {
    return colors.bright_pink;
  }

  return colors.assa_blue;
};

export default getPercentageGrowthColor;
